import React, { Component } from 'react'
import Helmet from 'react-helmet'
import Link from 'gatsby-link'
import styled, { injectGlobal } from 'styled-components'

// Components
import NavContainer from '../components/Nav'
import AgeCounter from '../components/Age'
import HeadScene from '../components/HeadScene'

const PageContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0; left: 0;
  right: 0; bottom: 0;
`;

const HeadContainer = styled.div`
  width: 100vw;
  height: 350px;

  @media (min-width: 520px) {
    height: 400px;
  }
  @media (min-width: 1400px) {
    height: 500px;
  }
`;

class WhoPage extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <PageContainer>
        <HeadContainer>
          <HeadScene />
        </HeadContainer>

        <NavContainer>
          <Link to={`/what`} activeClassName="active">what</Link>
          <Link to={`/who`} activeClassName="active">who</Link>
          <Link to={`/where`} activeClassName="active">where</Link>
          {/*<Link to={`/when`} activeClassName="active">when</Link>*/}
          <Link to={`/why`} activeClassName="active">why</Link>
        </NavContainer>
      </PageContainer>
    )
  }
}

export default WhoPage


// WEBPACK FOOTER //
// ./src/pages/who.js